// extracted by mini-css-extract-plugin
module.exports = {"empty":"EmptyReviewBlock_empty__IJ13c","emptyText":"EmptyReviewBlock_emptyText__ssZ3o","emptyImg":"EmptyReviewBlock_emptyImg__bvJrj"};